import { ReactComponent as AccountCircle } from './assets/AccountCircle/24px.svg';
import { ReactComponent as AddIcon } from './assets/Add/24px.svg';
import { ReactComponent as AdminPanelSettings } from './assets/admin-panel-settings.svg';
import { ReactComponent as ArrowDown } from './assets/Arrows/Down/16px.svg';
import { ReactComponent as ArrowUp } from './assets/Arrows/Up/16px.svg';
import { ReactComponent as ArrowLeft } from './assets/Arrows/Left/24px.svg';
import { ReactComponent as ArrowRight } from './assets/Arrows/Right/24px.svg';
import { ReactComponent as AppsHome } from './assets/apps/home.svg';
import { ReactComponent as AppsDriverAx } from './assets/apps/driver-ax.svg';
import { ReactComponent as AppsFleetManagerAx } from './assets/apps/fleet-manager-ax.svg';
import { ReactComponent as AppsCustomerAx } from './assets/apps/customer-ax.svg';
import { ReactComponent as AppsLogisticsAx } from './assets/apps/logistics-ax.svg';
import { ReactComponent as AppsMaintenanceAx } from './assets/apps/maintenance-ax.svg';
import { ReactComponent as AppsAnalytics } from './assets/apps/analytics.svg';
import { ReactComponent as AppsContentManagement } from './assets/apps/content-management.svg';
import { ReactComponent as AppsSettings } from './assets/apps/settings.svg';
import { ReactComponent as Attachment } from './assets/Attachment/16px.svg';
import { ReactComponent as BellIcon } from './assets/Bell/24px.svg';
import { ReactComponent as BillingCard } from './assets/Billing/Card/24px.svg';
import { ReactComponent as BillingCVC } from './assets/Billing/CVC/24px.svg';
import { ReactComponent as BrandingLarge } from './assets/Branding/large.svg';
import { ReactComponent as BrandingSmall } from './assets/Branding/small.svg';
import { ReactComponent as Building } from './assets/Building/24px.svg';
import { ReactComponent as Burger } from './assets/Burger/24px.svg';
import { ReactComponent as Calendar } from './assets/Calendar/24px.svg';
import { ReactComponent as CalendarOutline } from './assets/Calendar/Outline/24px.svg';
import { ReactComponent as ChartFilled } from './assets/Chart/Filled/24px.svg';
import { ReactComponent as ChartOutlined } from './assets/Chart/Outline/24px.svg';
import { ReactComponent as ChartPie } from './assets/chart-pie.svg';
import { ReactComponent as Checkmark } from './assets/Checkmark/24px.svg';
import { ReactComponent as ChevronDown } from './assets/Chevron/Down/24px.svg';
import { ReactComponent as ChevronUp } from './assets/Chevron/Up/24px.svg';
import { ReactComponent as ChevronUpDown } from './assets/Chevron/up-down.svg';
import { ReactComponent as ChevronLeft } from './assets/Chevron/Left/24px.svg';
import { ReactComponent as ChevronRight } from './assets/Chevron/Right/24px.svg';
import { ReactComponent as CircleCheckmark } from './assets/Circle Checkmark/24px.svg';
import { ReactComponent as CircleCheckmark2 } from './assets/circleCheckmark2.svg';
import { ReactComponent as CircleEmpty } from './assets/circleEmpty.svg';
import { ReactComponent as Clock } from './assets/Clock.svg';
import { ReactComponent as Comment } from './assets/Comment/20px.svg';
import { ReactComponent as Copy } from './assets/Copy/24px.svg';
import { ReactComponent as CopyOutline } from './assets/Copy/Outline/24px.svg';
import { ReactComponent as CreateFile } from './assets/Create File/24px.svg';
import { ReactComponent as CreateTemplate } from './assets/Create Template/24px.svg';
import { ReactComponent as Cross } from './assets/Cross/24px.svg';
import { ReactComponent as CrossOutline } from './assets/Cross/Outline/24px.svg';
import { ReactComponent as Cup } from './assets/Cup/24px.svg';
import { ReactComponent as Database } from './assets/Database/24px.svg';
import { ReactComponent as Datasets } from './assets/Datasets/24px.svg';
import { ReactComponent as Dashboard } from './assets/Dashboard/24px.svg';
import { ReactComponent as Desktop } from './assets/Desktop/24px.svg';
import { ReactComponent as Dollar } from './assets/dollar.svg';
import { ReactComponent as DotsMenu } from './assets/Dots Menu/24px.svg';
import { ReactComponent as Drag } from './assets/Drag/24px.svg';
import { ReactComponent as EditFilled } from './assets/Edit/Filled/24px.svg';
import { ReactComponent as EditOutlined } from './assets/Edit/Outlined/24px.svg';
import { ReactComponent as Export } from './assets/Export/24px.svg';
import { ReactComponent as Eye } from './assets/Eye/24px.svg';
import { ReactComponent as File_Upload } from './assets/File_Upload/24px.svg';
import { ReactComponent as Filters } from './assets/Filters/24px.svg';
import { ReactComponent as FiltersOff } from './assets/Filters/Off/24px.svg';
import { ReactComponent as FiltersOutline } from './assets/Filters/Outline/24px.svg';
import { ReactComponent as FindInPage } from './assets/FindInPage/24px.svg';
import { ReactComponent as Flag } from './assets/Flag/24px.svg';
import { ReactComponent as Fullscreen } from './assets/Fullscreen/24px.svg';
import { ReactComponent as FullscreenOutline } from './assets/Fullscreen/Outline/24px.svg';
import { ReactComponent as GasStation } from './assets/gas-station.svg';
import { ReactComponent as Grid } from './assets/Grid/24px.svg';
import { ReactComponent as Group } from './assets/group.svg';
import { ReactComponent as Help } from './assets/Help/24px.svg';
import { ReactComponent as HelpFilled } from './assets/HelpFilled/24px.svg';
import { ReactComponent as Home } from './assets/Home/24px.svg';
import { ReactComponent as Info } from './assets/Info/24px.svg';
import { ReactComponent as Integration } from './assets/Integration/24px.svg';
import { ReactComponent as Invoice } from './assets/Invoice/24px.svg';
import { ReactComponent as KebabMenu } from './assets/Kebab Menu/24px.svg';
import { ReactComponent as KebabOutline } from './assets/Kebab Menu/Outline/24px.svg';
import { ReactComponent as Keyboard } from './assets/Keyboard/24px.svg';
import { ReactComponent as LeftPanelClose } from './assets/LeftPanelClose/24px.svg';
import { ReactComponent as LibraryAdd } from './assets/library-add.svg';
import { ReactComponent as Locale } from './assets/Locale/24px.svg';
import { ReactComponent as Lock } from './assets/lock.svg';
import { ReactComponent as LongArrow } from './assets/long-arrow.svg';
import { ReactComponent as Mail } from './assets/Mail/24px.svg';
import { ReactComponent as Mention } from './assets/Mention/20px.svg';
import { ReactComponent as Missed } from './assets/missed.svg';
import { ReactComponent as Minus } from './assets/Minus/24px.svg';
import { ReactComponent as Move } from './assets/Move/24px.svg';
import { ReactComponent as PersonSearch } from './assets/person-search.svg';
import { ReactComponent as NavigationGoals } from './assets/Navigation/Goals.svg';
import { ReactComponent as NavigationMetrics } from './assets/Navigation/Metrics.svg';
import { ReactComponent as NoteStackAdd } from './assets/NoteStackAdd/24px.svg';
import { ReactComponent as OpenLink } from './assets/Open Link/24px.svg';
import { ReactComponent as Phone } from './assets/Phone/24px.svg';
import { ReactComponent as PushPin } from './assets/Push-pin/24px.svg';
import { ReactComponent as Refresh } from './assets/Refresh/24px.svg';
import { ReactComponent as Search } from './assets/Search/24px.svg';
import { ReactComponent as SettingsEmpty } from './assets/Settings/Empty/24px.svg';
import { ReactComponent as SettingsFilled } from './assets/Settings/Filled/24px.svg';
import { ReactComponent as Share } from './assets/Share/24px.svg';
import { ReactComponent as ShieldCheck } from './assets/shield-check.svg';
import { ReactComponent as SidePanels } from './assets/SidePanels/24px.svg';
import { ReactComponent as SidePanelsHidden } from './assets/SidePanelsHidden/24px.svg';
import { ReactComponent as Shared } from './assets/shared.svg';
import { ReactComponent as SLA } from './assets/SLA/24px.svg';
import { ReactComponent as Sparkles } from './assets/Sparkles/24px.svg';
import { ReactComponent as SparklesOutline } from './assets/Sparkles/Outline/24px.svg';
import { ReactComponent as Speaker } from './assets/speaker.svg';
import { ReactComponent as StarEmpty } from './assets/Star/Empty/24px.svg';
import { ReactComponent as StarFilled } from './assets/Star/Filled/24px.svg';
import { ReactComponent as Subscription } from './assets/Subscription/24px.svg';
import { ReactComponent as Table } from './assets/Table/24px.svg';
import { ReactComponent as Tablet } from './assets/Tablet/24px.svg';
import { ReactComponent as ThumbUp } from './assets/thumb-up.svg';
import { ReactComponent as ThumbDown } from './assets/thumb-down.svg';
import { ReactComponent as UI } from './assets/ui.svg';
import { ReactComponent as Updates } from './assets/Updates/24px.svg';
import { ReactComponent as VisibilityOff } from './assets/visibility_off/24px.svg';
import { ReactComponent as Warning } from './assets/Warning/24px.svg';
import { ReactComponent as Workspace } from './assets/Workspace/24px.svg';
import { ReactComponent as WrenchSparkles } from './assets/Wrench Sparkles/24px.svg';
import { ReactComponent as CloudDownload } from './assets/Cloud Download/cloud-download.svg';
import { ReactComponent as Moon } from './assets/Moon/16px.svg';
import { ReactComponent as Sun } from './assets/Sun/16px.svg';

import styled from 'styled-components';
import React from 'react';

export const IconMap: Record<
  Kingpin.Icon,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  'account-circle': AccountCircle,
  add: AddIcon,
  'admin-panel-settings': AdminPanelSettings,
  'arrow-down': ArrowDown,
  'arrow-up': ArrowUp,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'apps-home': AppsHome,
  'apps-driver-ax': AppsDriverAx,
  'apps-fleet-manager-ax': AppsFleetManagerAx,
  'apps-customer-ax': AppsCustomerAx,
  'apps-logistics-ax': AppsLogisticsAx,
  'apps-maintenance-ax': AppsMaintenanceAx,
  'apps-analytics': AppsAnalytics,
  'apps-content-management': AppsContentManagement,
  'apps-settings': AppsSettings,
  attachment: Attachment,
  bell: BellIcon,
  'billing-card': BillingCard,
  'billing-csv': BillingCVC,
  'branding-large': BrandingLarge,
  'branding-small': BrandingSmall,
  building: Building,
  burger: Burger,
  calendar: Calendar,
  'calendar-outline': CalendarOutline,
  'chart-filled': ChartFilled,
  'chart-outlined': ChartOutlined,
  'chart-pie': ChartPie,
  checkmark: Checkmark,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'chevron-up-down': ChevronUpDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  circleCheckmark: CircleCheckmark,
  circleCheckmark2: CircleCheckmark2,
  circleEmpty: CircleEmpty,
  clock: Clock,
  'cloud-download': CloudDownload,
  copy: Copy,
  'copy-outline': CopyOutline,
  comment: Comment,
  'create-file': CreateFile,
  'create-template': CreateTemplate,
  cross: Cross,
  'cross-outline': CrossOutline,
  cup: Cup,
  database: Database,
  datasets: Datasets,
  dashboard: Dashboard,
  desktop: Desktop,
  dollar: Dollar,
  'dots-menu': DotsMenu,
  drag: Drag,
  'edit-filled': EditFilled,
  'edit-outline': EditOutlined,
  export: Export,
  eye: Eye,
  fileUpload: File_Upload,
  filters: Filters,
  'filters-off': FiltersOff,
  'filters-outline': FiltersOutline,
  'find-in-page': FindInPage,
  flag: Flag,
  fullscreen: Fullscreen,
  'fullscreen-outline': FullscreenOutline,
  'gas-station': GasStation,
  grid: Grid,
  group: Group,
  help: Help,
  'help-filled': HelpFilled,
  home: Home,
  info: Info,
  integration: Integration,
  invoice: Invoice,
  kebabMenu: KebabMenu,
  'kebab-outline': KebabOutline,
  keyboard: Keyboard,
  'left-panel-close': LeftPanelClose,
  'library-add': LibraryAdd,
  locale: Locale,
  lock: Lock,
  'long-arrow': LongArrow,
  mail: Mail,
  mention: Mention,
  missed: Missed,
  minus: Minus,
  moon: Moon,
  move: Move,
  'navigation-goals': NavigationGoals,
  'navigation-metrics': NavigationMetrics,
  'note-stack-add': NoteStackAdd,
  'open-link': OpenLink,
  phone: Phone,
  'person-search': PersonSearch,
  pushPin: PushPin,
  refresh: Refresh,
  search: Search,
  'settings-empty': SettingsEmpty,
  'settings-filled': SettingsFilled,
  share: Share,
  shared: Shared,
  'shield-check': ShieldCheck,
  'side-panels': SidePanels,
  'side-panels-hidden': SidePanelsHidden,
  sla: SLA,
  sparkles: Sparkles,
  'sparkles-outline': SparklesOutline,
  speaker: Speaker,
  'star - empty': StarEmpty,
  'start - filled': StarFilled,
  subscription: Subscription,
  sun: Sun,
  table: Table,
  tablet: Tablet,
  'thumb-up': ThumbUp,
  'thumb-down': ThumbDown,
  ui: UI,
  updates: Updates,
  visibilityOff: VisibilityOff,
  warning: Warning,
  workspace: Workspace,
  'wrench-sparkles': WrenchSparkles,
};

export const IconWrapper = styled.div<{ width: number; height: number }>`
  display: flex;
  // Getting some interference from ag-grid.
  // This exists to get around it
  // There is certainly a better way to do this, but I have no time
  svg {
    margin: 0 !important;
    width: ${(props) => props.width}px !important;
    height: ${(props) => props.height}px !important;
  }
`;

type IconProps = {
  icon: Kingpin.Icon;
  color?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  testId?: string;
};

const Icon = ({
  icon,
  color = 'var(--color-grey-1)',
  width = 16,
  height = 16,
  style,
  testId,
}: IconProps) => {
  const IconComp = IconMap[icon];
  if (!IconComp) {
    return null;
  }

  return (
    <IconWrapper height={height} width={width} data-testid={testId}>
      <IconComp color={color} width={width} height={height} style={style} />
    </IconWrapper>
  );
};

class IconErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

const SafeIcon = (props: IconProps) => (
  <IconErrorBoundary>
    <Icon {...props} />
  </IconErrorBoundary>
);

export default SafeIcon;
